/* global self */
import { default as cssBlankPseudoInit } from './browser';
self.cssBlankPseudoInit = cssBlankPseudoInit;
